import { useSyncExternalStore } from 'react';
import {
  getHttpInFlightCount,
  subscribeHttpInFlight,
} from '@/utils/httpClient';

/**
 * Subscribes to the global in-flight HTTP request counter maintained
 * by `httpClient`. Returns the current count; the consumer renders a
 * loader when it's > 0.
 *
 * Uses `useSyncExternalStore` for tear-free updates under React 18
 * concurrent rendering — the hook always reads the latest value at
 * commit time, so the backdrop never flashes a stale state.
 */
export const useHttpInFlight = (): number =>
  useSyncExternalStore(subscribeHttpInFlight, getHttpInFlightCount);

export default useHttpInFlight;
